import { observer } from "mobx-react";
import * as React from "react";

interface LoadingPageProps {
}

interface LoadingPageState {
}

@observer
export class LoadingPage extends React.Component<LoadingPageProps, LoadingPageState>{

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <>
                <div className="loader" />
                <div className="text-loader">
                    <p style={{ fontSize: "14px" }}>Carregando Sistema, aguarde...</p>
                </div>
            </>
        );
    }
}

export default LoadingPage;
